<template>
    <h5-dialog :show-close-button="$route.name !== 'ResetPassword'" @close="emitClose">
        <template v-slot:header>
            <div class="dialog-header_title">
                <nav-back-button v-show="type==='forgot'"/>
                {{ type === 'forgot' ? $t('找回密码') : $t('修改密码') }}
            </div>
        </template>
        <div class="form">
            <template v-if="resetByPhone">
                <div class="form-item">
                    <input
                        type="text"
                        :placeholder="$t('请输入邮箱')"
                        class="form-item__inner"
                        v-model="formData.mobile"
                    >
                </div>
                <div class="form-item">
                    <verify-code :mobile="formData.mobile" v-model="formData.code"></verify-code>
                </div>
            </template>
            <template v-else>
                <div class="form-item">
                    <input
                        type="text"
                        :placeholder="$t('请输入旧密码')"
                        class="form-item__inner"
                        v-model="formData.password"
                    >
                </div>
            </template>
            <div class="form-item">
                <input
                    type="text"
                    :placeholder="$t('请输入新密码')"
                    class="form-item__inner"
                    v-model="formData.newpassword"
                >
            </div>
            <div class="form-item">
                <input
                    type="text"
                    :placeholder="$t('请确认新密码')"
                    class="form-item__inner"
                    v-model="formData.repassword"
                >
            </div>
        </div>
        <template v-slot:footer>
            <button class="btn btn-block btn-primary" @click="handleResetPassword">{{ $t('确认') }}</button>
        </template>
    </h5-dialog>
</template>

<script>
import { mapState } from 'vuex'
import H5Dialog from '@/components/H5Dialog'
import VerifyCode from '@/components/VerifyCode'
import NavBackButton from '@/components/NavBackButton'
// import { changePassword, resetPassword } from '@/service'
import { resetPasswordEmail } from '@/service'
import { $t } from '@/utils/languages'

export default {
    props: {
        type: {
            default: 'forgot',
            type: String,
        },
    },
    name: 'ResetPassword',
    components: { NavBackButton, VerifyCode, H5Dialog },
    data() {
        return {
            formData: {
                mobile: '',
                code: '',
                password: '',
                repassword: '',
                newpassword: '',
            },
            resettingPassword: false,
        }
    },
    computed: {
        ...mapState({
            userDetail: state => state.user.userDetail,
        }),
        resetByPhone() {
            return this.type === 'forgot' || this.userDetail.email
        }
    },
    methods: {
        handleResetPassword() {
            // const { resetByPhone } = this
            // const api = resetByPhone ? resetPassword : changePassword
            // let params = {}
            // if (resetByPhone) {
            //     params = {
            //         mobile: this.formData.mobile,
            //         code: this.formData.code,
            //         password: this.formData.newpassword,
            //         repassword: this.formData.repassword,
            //     }
            // } else {
            //     params = {
            //         newpassword: this.formData.newpassword,
            //         repassword: this.formData.repassword,
            //         password: this.formData.password,
            //     }
            //     // if (this.userDetail.mobile) {
            //     //     params.mobile = this.formData.mobile
            //     //     params.code = this.formData.code
            //     // }
            // }
            const api = resetPasswordEmail
            const params = {
                email: this.formData.mobile,
                code: this.formData.code,
                password: this.formData.newpassword,
                repassword: this.formData.repassword,
            }
            if (!this.resettingPassword) {
                this.resettingPassword = true
                api(params).then(res => {
                    if (Number(res.code) === 0) {
                        this.$toast.success({
                            message: res.msg || $t('重置成功'),
                            onClose: () => {
                                if (this.type === 'forgot') {
                                    this.$router.replace({
                                        path: '/login',
                                        query: this.$store.state.app.originQuery,
                                    })
                                }
                                this.$emit('reset-success', res)
                            },
                        })
                    } else {
                        this.$toast(res.msg || $t('重置失败'))
                    }
                }).finally(() => {
                    this.resettingPassword = false
                })
            }
        },
        emitClose() {
            this.$emit('close')
        },
    },
}
</script>

<style scoped>
.nav-back-btn {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    /*height: max-content;*/
    width: 32px;
    height: 32px;
    line-height: 32px;
    margin: auto;
}
</style>
